import React from 'react';
import L from 'leaflet';
import { MapCustomControl } from '../MapCustomControl';
import { IconButton } from '../../../components/IconButton/IconButton';
import { ReactComponent as SoilSvg } from '../Icons/Soil.svg';
import { ReactComponent as Layers } from '../Icons/Layers.svg';
import styled, { useTheme } from 'styled-components';
import { IFieldSoilData } from '../PopUp/MapPopUp';
import { SoilDataTable } from '../PopUp/SoilDataTable';
import { themeGet } from '@styled-system/theme-get';

const MapControlButton = styled.div`
	background-color: ${themeGet('colors.secondary')};
	height: 47px;
	width: 49px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 25px;
	border: 2px solid rgba(0,0,0,0.3);
	box-shadow: 2px 2px 5px #888888;
	&:hover {
		background-color: ${themeGet('colors.primary')};
	}
`;

const ColoredDot = styled.div<{ color: string }>`
	&:before {
		content:"";
		width:10px;
		height:10px;
		border-radius:50%;
		background: ${props => props.color};
		display: flex;
		margin-top: 2px;
	}
`;

interface IVRSGeneralButtonTrayProps
{
	displayTray: boolean;
	fieldSoilData: IFieldSoilData[];
	mapRef: React.MutableRefObject<L.Map | undefined>;
	showSoilMapButton: boolean;
	showFieldBoundary: () => void;
	showSoilZone: () => void;
}

export const VRSGeneralButtonTray = (props: IVRSGeneralButtonTrayProps) =>
{
	const { displayTray, fieldSoilData, mapRef, showSoilMapButton, showFieldBoundary, showSoilZone } = props;

	const theme = useTheme();

	const addCustomControl = (control: React.ReactElement, position: 'topleft' | 'topright' | 'bottomleft' | 'bottomright' | undefined) =>
	{
		return (
			<MapCustomControl map={mapRef.current} position={position} show={displayTray}>
				<MapControlButton>
					{control}
				</MapControlButton>
			</MapCustomControl>
		);
	};

	const addCustomLegend = (control: React.ReactElement, position: 'topleft' | 'topright' | 'bottomleft' | 'bottomright' | undefined) =>
	{
		return (
			<MapCustomControl map={mapRef.current} position={position} show={displayTray} zIndex='799'>
				{control}
			</MapCustomControl>
		);
	};

	return (
		<div>
			{
				showSoilMapButton && addCustomControl(
					<IconButton
						tooltip='Show Soil Zones'
						placement='left'
						onClick={showSoilZone}
						fillcolor='white'
					>
						<SoilSvg height={40} width={40} style={{ position: 'relative' }} />
					</IconButton>,
					'topright'
				)
			}
			{
				!showSoilMapButton && addCustomControl(
					<IconButton
						tooltip='Show Field'
						placement='left'
						onClick={showFieldBoundary}
						fillcolor='white'
					>
						<Layers height={25} width={25} style={{ position: 'relative' }} />
					</IconButton>,
					'topright'
				)
			}
			{
				!showSoilMapButton && addCustomLegend(
					<div style={{
						width: 400,
						backgroundColor: 'white',
						position: 'relative',
						top: -60,
						right: -2,
						paddingTop: 14,
						paddingBottom: 20,
						paddingRight: 20,
						paddingLeft: 20
					}}>
						<div style={{
							fontSize: theme.fontSizes.large,
							fontFamily: theme.fonts.heading,
							fontWeight: theme.fontWeights.bold,
							position: 'relative',
							top: -5
						}}>
							Soil Information
						</div>
						<div style={{ position: 'relative', top: -4, color: theme.colors.primary, fontSize: theme.fontSizes.normal }}>
							Field Details
						</div>
						<SoilDataTable data={fieldSoilData} isVrs={true} />
					</div>,
					'topright'
				)
			}
		</div>
	);
};